var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0{display:none;}\r\n\t.st1{fill:#7B7B7B;}\r\n\t.st2{fill:#CCCCCC;}\r\n\t.st3{fill:#9A9A9A;}\r\n\t.st4{fill:#057EF8;}\r\n\t.st5{fill:#083B74;}\r\n\t.st6{fill:#FE0000;}\r\n\t.st7{display:none;fill:#FFFFFF;}\r\n\t.st8{font-family:'LEMONMILK-Bold';}\r\n\t.st9{font-size:72px;}\r\n\t.st10{fill:#FFFFFF;}\r\n");
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Livello_2"
}, /*#__PURE__*/React.createElement("rect", {
  x: 229.9,
  y: 251.2,
  className: "st1",
  width: 65,
  height: 44
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 140.4,
  y: 278.1,
  className: "st2",
  width: 244,
  height: 50
}), /*#__PURE__*/React.createElement("rect", {
  x: 140.4,
  y: 304.8,
  className: "st3",
  width: 244,
  height: 23.2
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
  className: "st2",
  cx: 262.4,
  cy: 146.3,
  rx: 123,
  ry: 118.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st4",
  cx: 262.4,
  cy: 153.8,
  r: 72.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "st5",
  cx: 262.4,
  cy: 155,
  r: 52.5
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M352.4,227c-22.5,23.2-54.5,37.7-90,37.7c-67.9,0-123-53.1-123-118.5c0-5.1,0.3-10.2,1-15.2 c0,0,26.1,86,92.2,104.2S337,232.2,352.4,227z"
})), /*#__PURE__*/React.createElement("rect", {
  x: 139.9,
  y: 360.8,
  className: "st6",
  width: 245,
  height: 114.1
}), /*#__PURE__*/React.createElement("text", {
  transform: "matrix(1 0 0 1 175.6353 446.1801)",
  className: "st7 st8 st9"
}, "LIVE"), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M217.3,432v14.1h-36.7v-56.7h15V432H217.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M223.7,389.5h15v56.7h-15V389.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M303.4,389.5l-26.1,57.3h-6.8l-26-57.3h16.3l13.1,30.7l13.1-30.7H303.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M323.9,403.5v7.9h18V424h-18v8.1h21.9v14.1H309v-56.7h36.7v14H323.9z"
})));
function SvgWebcam(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    id: "Livello_1",
    className: "st0"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      display: "inline",
      overflow: "visible"
    },
    width: 512,
    height: 512,
    xlinkHref: "webcam.png",
    transform: "matrix(0.9644 0 0 0.9644 18.2017 7.5302)"
  })), _ref3);
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebcam);
export default __webpack_public_path__ + "static/media/webcam.3a454703fbbaa7549d31c40d0a64d50c.svg";
export { ForwardRef as ReactComponent };